import "../styles/style.scss";

function rotateFunction(){
    const min = 1024;
    const max = 9999;
    const deg = Math.floor(Math.random() * (max - min)) + min;
    document.getElementById('wheel').style.transform = "rotate("+deg+"deg)";
    setTimeout(() => {
       document.querySelector(".wheel__form").classList.remove("d-none");        
    }, 2600);
    setTimeout(() => {
        document.querySelector(".wheel svg").classList.add("d-none");
        document.querySelector(".wheel__btn").classList.add("d-none");
    }, 2650);
}

if(document.querySelector(".wheel__btn")) {
    document.querySelector(".wheel__btn").addEventListener('click', rotateFunction);
}

if(document.getElementById("generate")) {
    document.getElementById("generate").addEventListener('click', () => {
        document.querySelector(".wheel__form > .wrap").classList.add('opacity-0');
        document.querySelector(".generate-msg").classList.remove('d-none');
    })  
}
